import {
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  HostListener, ElementRef,
} from "@angular/core";
import { OverviewDisplayComponent } from "@products/overview/overview-display-component.interface";
import { BaseProductDetailComponent } from "@products/base-product-detail.component";
import { Logger } from "@utils/logger";
import { Page, Component as BrComponent } from '@bloomreach/spa-sdk/';
import { ProductDetailConfiguration, TabName } from "@types";
import { OverviewComponentConfig } from "../overview-component.config";
import { FundDocument } from "@products/types/fund-document.type";
import { Subscription } from "rxjs";
import { SiteConfigService } from "@services/site-config.service";
import { AnalyticsService } from '@services/analytics.service';

import { FundHeaderService } from '@products/overview/services/fund-header.service';


const logger = Logger.getLogger("FundTabsComponent");

@Component({
  selector: "ft-fund-tabs",
  templateUrl: "./fund-tabs.component.html",
  styleUrls: ["./fund-tabs.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FundTabsComponent
  extends BaseProductDetailComponent
  implements OverviewDisplayComponent, OnInit, OnDestroy {

  hide1: boolean = false;
  isNFO : any;
  tabVal : string = '';

  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event: any) {
    const deltaY = window.scrollY - this.lastKnownScrollPosition;
    this.lastKnownScrollPosition = window.scrollY;
    let box: any = document.querySelector(".top-part");
    let box1: any = document.querySelector(".hello");
    let winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    let height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    let scrolled = (winScroll / height) * 100;
    const element: any = document.getElementById('page-content');
    if (element) {
      if (window.scrollY > (element.offsetTop + element.offsetHeight)) {
      }
    }

    let menu: any = document.getElementById("invest-now");
    let dummy: any = document.getElementById("dummy-row");
    if (
      (winScroll > 850 && window.innerWidth < 900) ||
      (winScroll > 800 && window.innerWidth > 900)
    ) {
      menu.classList.add("invest-now-fixed");
      menu?.classList.remove("d-none");
    } else {
      menu?.classList.add("d-none");
      menu.classList?.remove("invest-now-fixed");
    }
    if (deltaY > 0 && scrolled > 1.5) {
      box.classList.add("scroll-down");
      box1?.classList.remove("top-1");
      if (scrolled > 7) {
        setTimeout(() => {

          if (window.innerWidth < 700) {

            if (scrolled > 9) {
              box1.classList.remove('fund-header');
              // box1.classList.add('sticky-top1');
              box1?.classList.add('mobile-header-sticky');
            }
            // box.classList.add('test');
          } else {
            box1?.classList.remove('fund-header');
            box1?.classList.remove('sticky-top1')
            // (window.scrollY > element.offsetTop + element.offsetHeight)? '' :;
          }
        }, 100);
      }
    } else if (deltaY < 0 && scrolled > 1.5) {
      if (window.innerWidth > 700) {
        this.hide1 = true;
        if (deltaY < 0 && scrolled > 5) box.classList.add('test');
        box.classList.remove("scroll-down");
        box1?.classList.add('sticky-top1');
      } else {
        if (scrolled < 9) {
        }
        box1?.classList.add('top-1');
      }
    }
    if (deltaY < 0 && scrolled < 6) {
      box.classList.remove("test");
      box1?.classList.remove('sticky-top1');
      this.hide1 = true;
      box1?.classList.remove('top-1');
    }
    const sections = document.querySelectorAll<any>(".fd-tab-sections");
    const navLi = document.querySelectorAll(".FT-blocks-nav ul li");

    let current = "";
    sections.forEach((section) => {
      const sectionTop = section.offsetTop;
      if (pageYOffset >= (sectionTop - 85)) {
        current = section.getAttribute('id');
      }
    });
    //console.log("current: " + current);
    navLi.forEach((li) => {
      current ? li.children[0].classList.remove("active-item") : "";
      if (li.children[0].classList.contains(current)) {
        li.children[0].classList.add('active-item');
      }
    });
  }

  lastKnownScrollPosition!: number;
  dataSubscription: Subscription;
  fundDocument: FundDocument;
  fundName = '';
  fundTitle: string;
  isSegregated: boolean;
  isLoaded = false;
  tabs: { label: string; type: TabName }[];
  listOfTabs: string[] = [];

  constructor(
    private siteConfig: SiteConfigService,
    private elRef: ElementRef,    
    private analyticsService: AnalyticsService,
    private fundHeaderService: FundHeaderService,
    
    private cdr: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnInit() {
    this.elRef.nativeElement.closest('.br-container-box')?.classList.add('cont-first-main');
    this.elRef.nativeElement.closest('.br-container-box')?.children[0]?.classList.add('cont-first-main');

  }

  populate(
    componentConfig: OverviewComponentConfig,
    brConfig: ProductDetailConfiguration,
    component: BrComponent,
    page: Page
  ) {
    this.initialize(brConfig, component, page);
    if (this.brConfig.fundId) {
      this.setTabs();
      //TODO: Enable for Tab analytics if required later
      this.isSegregated = this.siteConfig.isSegregatedFund(
        this.brConfig.fundId
      );
      this.isNFO = this.siteConfig.isNfoFund(this.brConfig.fundId);
      //const documents = component.getModels()?.documents;

      //this.fundDocument = page.getContent(documents)?.getData<FundDocument>();

      this.dataSubscription = this.fundHeaderService.getFundHeaderState$()
        .subscribe(
          (fhState) => {
            if (this.isLoaded) {
              this.fundName = fhState.fundName;
            }
            this.isLoaded = true;
            this.cdr.detectChanges();
          },
          (error) => {
            logger.error(
              `Error in invoking fund information service: ${error}`
            );

            this.isLoaded = false;
            this.cdr.detectChanges();
          }
        );
      this.fundHeaderService.populate(this.brConfig);
      this.cdr.detectChanges();
    }
  }

  private setTabs() {
    const tabSet = this.siteConfig.getFundTabSet(this.brConfig.fundId);
    //console.log("tabSet:: " + tabSet.tabs);
    this.listOfTabs = tabSet.tabs;
    //console.log("listOfTabs:: " + this.listOfTabs);
    //TODO :  Temp fix Added this has to be modified later on once we have dedicated siteconfig for en-in-new
  }

  scrollTo(param: any) {
    const elementToScroll = document.getElementById(param);
      if (elementToScroll) {
      elementToScroll.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    }
    if(param === "overview"){
      this.tabVal = "Fund Overview" ;
    } else if (param === "more-details"){
      this.tabVal = "Other Details" ;
    } else {
      this.tabVal = param ;
    }
    this.analyticsService.trackEvent({
      event: 'Event FundPage',
      category: 'Fund Page',
      action: 'Tab: ' + this.tabVal ,
      label: this.fundName,
    });
  }

  ngOnDestroy(): void {
    this.dataSubscription?.unsubscribe();
  }

}
